export const EASINGS = {
  smooth: [0.22, 1, 0.36, 1],
  snappy: [0.16, 1, 0.3, 1],
  soft: [0.4, 0, 0.2, 1],
};

export const EASE = EASINGS.smooth;